// @flow

import { MarketplaceProduct } from '@atlassian/mpac-services-client';
import { foldMarketplaceProduct } from '@atlassian/mpac-site-selection';
import queryString from 'query-string';

import type { CompatibleProduct } from '@atlassian/mpac-app-listing';
import type {
  MarketplaceProduct as MarketplaceProductType,
  SelectedSiteAndProduct,
} from '@atlassian/mpac-site-selection';

type JiraConfluenceCompatibleProduct = {
  ...CompatibleProduct,
  id: MarketplaceProductType,
};

export const onlyJiraConfluenceProducts = (
  compatibleProducts: $ReadOnlyArray<CompatibleProduct>
): JiraConfluenceCompatibleProduct[] => // $FlowFixMe - Array#filter doesn't refine types https://github.com/facebook/flow/issues/1414
  compatibleProducts.filter(product =>
    [MarketplaceProduct.JIRA, MarketplaceProduct.CONFLUENCE].includes(product.id)
  );

const getEmceeAppListingPageLink = (
  appKey: string,
  { site, product }: SelectedSiteAndProduct,
  isForEndUser: boolean,
  additionalQueryParams: {| installDialogOpen?: boolean, requestDialogOpen?: boolean |}
) => {
  const queryParamString = queryString.stringify({ source: 'mpac', ...additionalQueryParams });
  const deeplink = `app/${appKey}?${queryParamString}`;
  const pageFragment = isForEndUser ? 'enduser-discover' : 'discover';

  return `${site.url}${foldMarketplaceProduct(product)(
    () => '/plugins/servlet/ac/com.atlassian.jira.emcee',
    () => '/wiki/plugins/servlet/ac/com.atlassian.confluence.emcee'
  )}/${pageFragment}#!/discover/${deeplink}`;
};

export const getEmceeAppListingInstallLink = (
  appKey: string,
  siteAndProduct: SelectedSiteAndProduct
) => {
  return getEmceeAppListingPageLink(appKey, siteAndProduct, false, { installDialogOpen: true });
};

export const getEmceeAppListingRequestAppLink = (
  appKey: string,
  siteAndProduct: SelectedSiteAndProduct
) => {
  return getEmceeAppListingPageLink(appKey, siteAndProduct, true, { requestDialogOpen: true });
};
